<template>
  <em
    :class="`${type}-${name}`"
    :style="style"
    v-bind="$attrs"
    v-on="$listeners"
  ></em>
</template>

<script>
/**
 * Icône, parmi ceux de Themify
 *
 * @link https://themify.me/themify-icons
 */
export default {
  name: 'UbiIcon',
  props: {
    /**
     * Type d'icône
     */
    name: { type: String, required: true },
    /**
     * Taille en pixel
     */
    size: { type: [Number, String] },
    /**
     * @ignore
     */
    type: { type: String, default: 'ti' }
  },
  computed: {
    style () {
      return this.size
        ? {
            fontSize:
              typeof this.size === 'number' || this.size.match(/^\d+$/)
                ? `${this.size}px`
                : this.size
          }
        : {}
    }
  }
}
</script>

<docs>
```jsx
<ubi-icon name="save" size="64" />
<ubi-icon name="location-pin" size="32" />
<ubi-icon name="wand" />
```
</docs>
